// A document cut out of a compilation file is a real row (container_id + page_start /
// page_end) named "<parent stem> - NN - <Title> (pp. a-b).pdf" so it sorts and exports
// well (backend: domain/segmentation/materialize.child_filename). On screen the parent
// and the pages have their own line, so a card or a row shows just the title.

import { displayTitle } from './titleCase';

export const isCutChild = (doc) => !!doc && doc.page_start != null && !!doc.container_id;

const PAGES_SUFFIX = /\s*\(pp\. \d+-\d+\)$/;
const INDEX_SEP = / - \d{2,4} - /g;

// {title, parentStem}. With the parent's filename the split is exact; without it, the
// LAST " - NN - " separates them (a title holding one is rarer than a file name holding one).
export function cutChildParts(filename, parentFilename = null) {
  const name = String(filename || '').replace(/\.pdf$/i, '').replace(PAGES_SUFFIX, '');
  const stem = parentFilename ? String(parentFilename).replace(/\.[^.]+$/, '') : null;
  const tidy = (t) => displayTitle(t) || t;
  if (stem && name.startsWith(`${stem} - `)) {
    return { title: tidy(name.slice(stem.length + 3).replace(/^\d{2,4} - /, '') || name), parentStem: stem };
  }
  let last = null;
  for (const m of name.matchAll(INDEX_SEP)) last = m;
  if (!last) return { title: tidy(name || String(filename || '')), parentStem: stem || '' };
  return { title: tidy(name.slice(last.index + last[0].length) || name), parentStem: name.slice(0, last.index) };
}

export function childDisplayTitle(filename, parentFilename = null) {
  return cutChildParts(filename, parentFilename).title;
}

export const pagesRange = (start, end) => (end == null || end === start ? `p. ${start}` : `pp. ${start}–${end}`);
export const pagesLabel = (doc) => (doc?.page_start == null ? '' : pagesRange(doc.page_start, doc.page_end));

// Sort key that keeps a cut file directly above its documents, in reading order:
// "<stem>" < "<stem> - 01 - …" < "<stem> - 02 - …", whatever the extension.
export const nameSortKey = (doc) => String(doc?.filename || '').replace(/\.[^.\s]{1,5}$/, '');
